import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { PasswordResetPage } from './password-reset/password-reset.page';
import { AuthComponent } from './components/auth/auth.component';
import { TrainingPage } from './training/training.page';

@Injectable({
    providedIn: 'root'
})
export class AppLinkService {
    private readonly api = inject(ApiService);
    private readonly auth = inject(AuthService);
    private readonly modalController = inject(ModalController);
    private readonly associatedDomains = new Set(['app.aitempo.online']);

    isAssociatedDomainUrl(url: string | undefined | null) {
        if (!url) {
            return false;
        }

        try {
            const parsedUrl = new URL(url);
            return this.associatedDomains.has(parsedUrl.host);
        } catch {
            return false;
        }
    }

    async handleUrl(url: string | undefined | null) {
        if (!this.isAssociatedDomainUrl(url)) {
            return false;
        }

        const parsedUrl = new URL(url!);
        const slugParts = parsedUrl.pathname.split('/').filter(Boolean);
        const route = slugParts[0];
        const value = slugParts[1];

        if (!route) {
            return false;
        }

        if (route === 'verify' && value) {
            const vres = await this.api.checkVerifyCode(value);
            if (vres.valid) {
                window.open('/', '_self');
            } else {
                this.api.presentAlert('Errore', 'Questo link non è più valido o è stato già utilizzato.');
            }
            return true;
        }

        if (route === 'passreset' && value) {
            const modal = await this.modalController.create({
                component: PasswordResetPage
            });
            await modal.present();
            const { data } = await modal.onDidDismiss();
            if (data) {
                await this.api.resetPasswordFromEmail(value, data.password);
                await this.api.setEmailLogin('true');
                window.open('/', '_self');
            }
            return true;
        }

        if (route === 'invite' && value) {
            const gid = Number(value);
            const g = await this.api.groupById(gid);
            this.auth.setEmbedGroupSubscribe(g.group);
            await this.auth.updateUser();
            return true;
        }

        if (route === 'embed' && value) {
            const mcheck = await this.modalController.getTop();
            if (mcheck?.component === AuthComponent) {
                await mcheck.dismiss();
            }

            const res = await this.setupTraining(Number(value));
            if (!res?.t) {
                this.api.presentAlert('Errore', 'Questo contenuto non esiste o è stato eliminato.');
                return true;
            }

            const modal = await this.modalController.create({
                component: TrainingPage,
                componentProps: {
                    t: res.t,
                    embGroup: res.embGroup
                }
            });
            await modal.present();
            return true;
        }

        return false;
    }

    private async setupTraining(tid: number) {
        const tres = await this.api.getSingleTraining(tid);
        if (tres.trainings.length === 0) {
            return null;
        }

        const t = tres.trainings[0];
        const tquests = await this.api.getTrainingQuest(t.tid);
        t.questions = tquests.questions;

        const gres = await this.api.groupById(t.gid);
        const embGroup = gres.group;

        return { t, embGroup };
    }
}
